// extracted by mini-css-extract-plugin
export default {"container":"User_container__lAI6V","edit":"User_edit__cQ6Ud","icon":"User_icon__NslFv","content":"User_content__JwAha","nav":"User_nav__10+1I","rotate":"User_rotate__oOc9r"};